interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav aria-label="分页" className="mt-10 flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="上一页"
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/80 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/80 disabled:hover:text-foreground-600"
      >
        <i className="ri-arrow-left-s-line text-base" />
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`h-9 min-w-[36px] cursor-pointer rounded-md border px-3 font-label text-xs transition-colors ${
            item === page
              ? "border-primary-950 bg-primary-950 font-semibold text-background-50"
              : "border-background-300/80 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="下一页"
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/80 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/80 disabled:hover:text-foreground-600"
      >
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}